<template>
    <div style="float: left;width: 100%;">
        <div class="col-3" v-if="!read">
            <div class="uploadIcon" @click="triggerUpload">
                <van-icon style="vertical-align: middle;" name="plus" size="3em"/>
            </div>
            <form style="display: none;" ref="upload">
                <input :id="refName" :ref="refName" type="file" name="uploadFile" @change="upload" multiple>
            </form>
        </div>
        <div class="col-3" v-for="(item,index) in files">
            <van-icon v-if="!read" class="delClz" name="clear" size="20px" @click="deleteFile(item)"/>
            <img v-if="item.fileType == '图片'" width="80" height="80" :src="item.fileUrl" @click="showImage(index)"/>
            <img v-else width="80" height="80" :src="icFile" @click="downFile(item)"/>
            <p>{{item.fileName}}</p>
        </div>

    </div>
</template>

<script>
    import { getFiles, delFile, uploads} from '@/api/loanInfo'
    import { eventBus } from '../../../../vue/utils/eventBus'
    import icFile from '@/assets/home/ic_file.png'
    import { mapGetters } from 'vuex'
    import { ImagePreview } from 'vant'

    export default {
        name: 'files_upload',
        props: {
            applyId: {
                type: String,
                default: ''
            },
            groupCode: {
                type: Number,
                default: ''
            },
            refName: {
                type: String,
                default: ''
            },
            isUpload:{
                type: Boolean,
                default: false,
            }
        },
        computed: mapGetters([
            'auditStatus',
            'applyInfo',
        ]),
        data() {
            return {
                showUpload: true,
                loading: false,
                finished: false,
                read: true,
                images: [],
                files: [],
                icFile: icFile
            }
        },
        mounted() {
            let self = this

            //根据当前流程节点判断获取附件
            this.initData()
            setTimeout(function () {
                //console.log('尽职调查防止刷新—>' + self.auditStatus)
                 //尽职调查
                if (self.auditStatus == '1' && self.groupCode == '37') {
                    self.read = false
                }else if (self.auditStatus == '3' && self.groupCode == '70') {
                    //初审附件
                    self.read = false
                }else if (self.auditStatus == '7' && (self.groupCode == '67' || self.groupCode == '202' || self.groupCode == '203' || self.groupCode == '204'|| self.groupCode == '205' )) {
                    //合同文书
                    self.read = false
                }else if (self.auditStatus == '8' || self.auditStatus == '9'|| self.auditStatus == '10' ) {
                    //抵押附件
                    self.read = false
                }else{
                    self.read=!self.isUpload
                }
            },300)
        },
        methods: {
            initData() {
                this.images = []
                this.getFileList()
            },
            getFileList() {
                let self = this
                let params = {
                    applyId: this.applyId,
                    customer: this.applyInfo.customerId,
                    groupCode: this.groupCode
                }
                getFiles(params).then(res => {
                    if (res.success) {
                        let pics = []
                        let documents = []
                        self.images = []
                        self.finished = true
                        self.loading = false
                        res.pageObj.result.forEach(item => {
                            if (item.fileType == '图片') {
                                self.images.push(item.fileUrl)
                                pics.push(item)
                            } else {
                                item.fileUrl = this.baseUrl + '/file/downloadFile?fileId=' + item.fileId + "&fileUri=" + item.fileUri
                                documents.push(item)
                            }
                        })
                        //合并文件（排序图片和文件）
                        self.files = pics.concat(documents);
                    }
                })
            },
            upload() {
                let self = this
                self.loadings()
                let formData = new FormData(this.$refs.upload)
                formData.append('applyId', this.applyId)
                formData.append('groupCode', this.groupCode)
                formData.append('customerId', this.applyInfo.customerId)
                uploads(formData).then(res => {
                    self.closeLoadings()
                    if (res.success) {
                        self.$toast('操作完成，上传成功：'+ res.count + "，失败：" + res.failure)
                        self.resetInputFile()
                        self.getFileList()
                    }
                }).catch(err => {
                    self.closeLoadings()
                })
            },
            deleteFile(file) {
                this.$dialog.confirm({
                    title: '删除',
                    message: '是否确认删除当前文件?'
                }).then(() => {
                    let data = {
                        customerFileId: file.customerFileId
                    }
                    delFile(data).then(res => {
                        this.$toast(res.msg)
                        this.getFileList()
                    })
                }).catch(() => {
                    // on cancel
                })
            },
            showImage(position) {
                const instance = ImagePreview({
                    images: this.images,
                    lazyLoad: true,
                    startPosition: typeof position === 'number' ? position : 0
                })
            },
            loadings() {
                this.$toast.loading({
                    duration: 0,
                    forbidClick: true,
                    loadingType: 'spinner',
                    message: '正在上传...'
                })
            },
            closeLoadings() {
                this.$toast.clear()
            },
            resetInputFile() {
                let file = document.getElementById(this.refName)
                file.value = ''
            },
            triggerUpload() {
                this.$refs[this.refName].dispatchEvent(new MouseEvent('click'))
            },
            downFile(file) {
                this.$dialog.confirm({
                    title: '下载文件',
                    message: '是否确认下载『'+ file.fileName + '』?'
                }).then(() => {
                    window.open(file.fileUrl,'_blank')
                }).catch(() => {
                    // on cancel
                })
            }
        }
    }
</script>

<style scoped>
    .uploadIcon {
        height: 80px;
        width: 80px;
        margin: 0 auto;
        line-height: 80px;
        border:1px dashed #afb1b3;
    }
    .col-3 {
        width: 33.3%;
        float: left;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .delClz {
        left: 90px;
        bottom: 70px;
    }
</style>
